import { render, staticRenderFns } from "./NewEmailGroup.vue?vue&type=template&id=0535828f&scoped=true"
import script from "./NewEmailGroup.vue?vue&type=script&lang=js"
export * from "./NewEmailGroup.vue?vue&type=script&lang=js"
import style0 from "./NewEmailGroup.vue?vue&type=style&index=0&id=0535828f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535828f",
  null
  
)

export default component.exports